import React, { createContext, useContext, useState, useEffect, useCallback } from "react";
import translations from "../i18n/translations";

const LanguageContext = createContext(null);

const LANG_NAMES = { fr: "Français", en: "English", es: "Español", ar: "العربية" };
const LANG_LIST = ["fr", "en", "es", "ar"];

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState(localStorage.getItem("dn_lang") || "fr");

  const setLang = useCallback((newLang) => {
    setLangState(newLang);
    localStorage.setItem("dn_lang", newLang);
    document.documentElement.dir = newLang === "ar" ? "rtl" : "ltr";
    document.documentElement.lang = newLang;
  }, []);

  useEffect(() => {
    document.documentElement.dir = lang === "ar" ? "rtl" : "ltr";
    document.documentElement.lang = lang;
  }, [lang]);

  const t = useCallback((key) => {
    return translations[lang]?.[key] || translations.fr[key] || key;
  }, [lang]);

  return (
    <LanguageContext.Provider value={{ lang, setLang, t, LANG_NAMES, LANG_LIST }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLang() {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLang must be used within LanguageProvider");
  return ctx;
}
